// extracted by mini-css-extract-plugin
module.exports = {"embeddedreport-wrapper":"EmbeddedReport_embeddedreport-wrapper__27Csj","embeddedreport":"EmbeddedReport_embeddedreport__1q66H"};